import { render, staticRenderFns } from "./payout_category_chart.vue?vue&type=template&id=613a607e&"
import script from "./payout_category_chart.vue?vue&type=script&lang=js&"
export * from "./payout_category_chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports